import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// Dans ton App.js (ou index.js)
import './styles/variables.css';  // 1. Les bases
import './styles/common.css';     // 2. Les utilitaires
import './App.css';        // 3. La structure globale
// ... ensuite tes pages
import Header from './components/header/Header';
import Footer from './components/footer/Footer';
import Home from './pages/Home';
import Resume from './pages/Resume/Resume';
import Skills from './pages/Skills/Skills';
import Projects from './pages/Projects/Projects';
import useFavicon from './hooks/useFavicon';

function App() {
  useFavicon();
  
  return (
    <Router>
      <div className="app">
        <Header />
        {/* On ajoute 'container' ici pour l'alignement universel */}
        <main className="main-content">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/resume" element={<Resume />} />
            <Route path="/skills" element={<Skills />} />
            <Route path="/projects" element={<Projects />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;